<template>
  <quiz-layout class="quiz-result">
    <template v-slot:active>{{ correctListLength | declOfNum(['правильный ответ', 'правильных ответа', 'правильных ответов']) }}</template>
    <template v-slot:length>{{ itemListLength }}</template>

    <h2 class="quiz-result__title">
      {{ result.title }}
    </h2>

    <p class="quiz-result__subtitle">{{ result.text }}</p>

    <template v-slot:footer>
      <double-btn iconName="redo" iconNameHover="redo-hover" @click="onAgain">Пройти тест еще раз</double-btn>
    </template>

    <template v-slot:image>
      <img class="quiz-layout__image" :src="picture">
    </template>
  </quiz-layout>
</template>

<script>
import QuizLayout from './QuizLayout'
import DoubleBtn from '../shared/DoubleBtn'
// utils
import { declOfNum } from '@/utils'
// assets
import QuizPicture from '../../assets/image/quiz_result@2x.jpg'

export default {
  components: {
    QuizLayout,
    DoubleBtn
  },
  props: {
    itemList: {
      type: Array,
      default: () => []
    },
    resultList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      picture: QuizPicture,
      isBtnHover: false
    }
  },
  computed: {
    correctListLength () {
      return this.itemList.filter(item => item).length
    },
    itemListLength () {
      return this.itemList.length
    },
    result () {
      const item = this.resultList.find(item => this.correctListLength >= item.min && this.correctListLength <= item.max)
      return item || { title: null, text: null }
    }
  },
  filters: {
    declOfNum
  },
  methods: {
    onAgain () {
      this.$emit('again')
    }
  }
}
</script>

<style lang="scss" scoped>
.quiz-result {
  &__title {
    @include font-size(24px);

    margin-bottom: 20px;
  }

  &__subtitle {
    @include font-size($font-size-lg);
  }
}
</style>
